<template>
    <div class="setmeal">
      <div class="container banner">
        <img src="../../static/img/about/banner.png" style="width: 100%;margin-bottom: 60px;" alt="">
        <div class="content">
          <div class="bread">
            您现在的位置：
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item >月子套餐</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="taggle-box">
              <ul>
                <li @click="setActive(item.id)" class="fun-carousel" :class="{'active':item.id===index?true:false}" v-for="item in diaryCarList" :key="item.id">
                  {{item.name}}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="env" v-if="index == 1">
          <div class="content">
            <h3 class="meal-title"><span class="title-line"></span>房型介绍<span class="title-line"></span></h3>
            <div class="env-a">
              <div class="env-a-item" v-for="item in envA" :key="item.id">
                <img :src="item.src" class="aImg" alt="">
                <div class="env-a-box">
                  <p class="name">{{item.name}}</p>
                  <p class="env-ann">{{item.ann}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="env-b">
            <div class="content">
              <h3 class="meal-title"><span class="title-line"></span>房型介绍<span class="title-line"></span></h3>
              <ul class="env-b-cate">
                <li class="b-item" v-for="item in envB" :key="item.id">
                  <img :src="item.src" class="imgB" alt="">
                  <div class="b-text">
                    <p class="b-name">{{item.name}}</p>
                    <div class="b-ann">{{item.ann}}</div>
                  </div>
                </li>
              </ul>
              <div style="clear: both"></div>
            </div>
          </div>
          <div class="content">
            <h3 class="meal-title"><span class="title-line"></span>房型介绍<span class="title-line"></span></h3>
            <p class="sub-title">月子中心不是旅馆，住房只是一个方面。一房一功能，才是品质保证。合美提供各类多功能性场所，让妈妈宝宝住的舒心，住的健康。</p>
            <div class="env-c">
              <div class="env-c-item" v-for="item in envC" :key="item.id">
                <img :src="item.src" class="cImg" alt="">
                <div class="env-c-box">
                  <p class="name">{{item.name}}</p>
                  <p class="env-ann">{{item.ann}}</p>
                </div>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
        <div class="server" v-if="index == 2">
          <div class="content">
            <div class="ser-a">
              <h3 class="meal-title"><span class="title-line"></span>五星环境服务<span class="title-line"></span></h3>
              <div class="ser-a-box">
                <div class="ser-a-item" v-for="item in serA" :key="item.id">
                  <img :src="item.src" class="aSer" alt="">
                  <p class="a-name">{{item.name}}</p>
                  <p class="a-ann">{{item.ann}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="ser-b">
            <div class="content">
              <h3 class="meal-title"><span class="title-line"></span>贴心妈妈护理<span class="title-line"></span></h3>
              <div class="b-content">
                <img src="../../static/img/setmeal/ser-b-1.png"  class="b-main-img" alt="">
                <div class="b-article">
                  1.产前健康顾问跟踪服务、孕期营养保健咨询指导。对孕妈家庭科普科学孕育保健，帮助孕妈缓解孕期不适，指导正确选择宝宝用品、生产方式等。
                  <br>
                  <br>
                  2.入住时专业医护人员、营养保健专家对母婴进行全面健康评估，包括了解生活习惯、饮食偏好，量身定制调理计划及科学月子膳食。
                  <br>
                  <br>
                  3.合美产康首席专家结合孕妈分娩、体质情况，制定产后康复方案，帮助每位妈妈恢复产前最佳状态，越生越美丽。
                  <br>
                  <br>
                  4.三甲医院产科主任、中医师、产后康复专家、月子美容管家等定期巡诊。及时发现疾病隐患，实时保障健康。
                  <br>
                  <br>
                  5.专业产后护理团队提供全天6对1、1对1等精准呵护。
                  <br>
                  <br>
                  6.24小时护理站婴儿托管服务，帮助妈妈更好地修养调理。
                  <br>
                  <br>
                  7.每日密切观察产妇体温、脉搏、呼吸、血压、体重、伤口、恶露、子宫复旧等情况，进行复原护理评估。
                  <br>
                  <br>
                  8.给予：母乳、人工、混合喂养等指导，合美特色韩通无痛辅助开奶，一套综合性独特开奶、乳房按摩保健、乳房疾病管理方法，有助于充分增加泌乳并且缓解乳房疼痛现象；解决产后母乳喂养问题；乳房按摩保健，哺乳期乳腺炎防治。
                  <br>
                  <br>
                  9.专业医护人员对妈妈情绪疏导、心理指导、抑郁评估。
                  <br>
                  <br>
                  10.一对一卫教指导新生儿护理及婴幼儿教育和心理发展。
                </div>
                <div class="photo">
                  <img src="../../static/img/setmeal/ser-b-2.png" alt="">
                  <img src="../../static/img/setmeal/ser-b-3.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="ser-c">
              <h3 class="meal-title"><span clas="title-line"></span>宝宝专业护理<span class="title-line"></span></h3>
              <div class="c-article">
                1.	宝宝入馆体格检查（入馆体重、精神反应、皮肤黏膜、黄疸、头部五等），制定系列监测、护理、指导喂养方案。
                <br>
                <br>
                2.新生儿科医生每日查房，（反应、哭声、饮食、吸吮力、肤色、头眼鼻耳口心肺腹肝脾、脐带、四肢、臀部、拥抱反射等），发现异常情况立即请新生儿医生诊治或免费协助送新生儿科。
                <br>
                <br>

                3.每日检查婴儿生长发育情况，测量记录体温、体重、皮肤，大小便等。同时对宝宝的发烧、腹胀、腹泻等症状做好预防工作；每周测量并记录一次身长；再根据宝宝的身体情况、个人体质评估，制定或调整专属的照护计划。
                <br>
                <br>

                4.对人工喂养或混合喂养的宝宝制定科学喂养方案，严格新生儿喂养记录（奶量、水量、大小便情况等）；全程母乳/专业护士协助，配方奶/专业护士冲调奶粉、喂奶，高压灭菌奶具消毒等。
                <br>

                5.责任护士新生儿常规护理：宝宝沐浴、游泳、每日抚触按摩、换尿片，脐部、口腔、眼部、耳朵、指甲、臀部、生殖器护理等。
                <br>
                <br>

                6.五星配套设施+独立的婴儿室，24小时的全方位照顾。帮助宝宝培养良好的睡眠习惯及姿势，让您有足够的休息，同时让您回到家也可以轻松照顾宝宝。
                <div class="envi-c">
                  <img src="../../static/img/setmeal/ser-c-1.png" alt="">
                  <img src="../../static/img/setmeal/ser-c-2.png" alt="">
                </div>
              </div>
              <div class="c-botton-line"></div>
            </div>
          </div>
          <div class="ser-d">
            <div class="content">
              <h3 class="meal-title"><span class="title-line"></span>合美月子口碑<span class="title-line"></span></h3>
              <div class="d-content">
                <ul>
                  <li class="d-praise">
                    <span class="num">01</span>
                    <img src="" class="d-img" alt="">
                    <div class="d-praise-con">
                      <p class="praise-name">全面陪护</p>
                      <div class="praise-con">分娩出院专车入所   坐月子1V1+24小时护理<br>
                        家属特色专属餐食   新手爸妈免费课堂<br>
                        孕期写真新生儿照   出所宝妈指导服务<br>
                        （产后饮食指导、免费保健咨询、新生儿作息睡眠辅食指导、<br>
                        卫教育儿指导、育儿知识分享等）</div>
                    </div>
                  </li>
                  <li class="d-praise">
                    <span class="num">02</span>
                    <img src="" class="d-img" alt="">
                    <div class="d-praise-con">
                      <p class="praise-name">孕期护理</p>
                      <div class="praise-con">秘方中药养发头疗  孕期肿胀舒缓、防妊娠纹服务</div>
                    </div>
                  </li>
                  <hr style="clear: both">
                  <li class="d-praise">
                    <span class="num">03</span>
                    <img src="" class="d-img" alt="">
                    <div class="d-praise-con">
                      <p class="praise-name">产后康复</p>
                      <div class="praise-con">产后腰肩/下肢水肿舒缓护理   子宫复旧伤口红外理疗<br>
                        中药医学暖宫温阳服务   盆底肌腹直肌修复服务<br>
                        纤体塑性、乳房保养   产后42天盆底健康评估</div>
                    </div>
                  </li>
                  <li class="d-praise">
                    <span class="num">04</span>
                    <img src="" class="d-img" alt="">
                    <div class="d-praise-con">
                      <p class="praise-name">全套用品</p>
                      <div class="praise-con">暖吸汗月子服、产妇专用护齿套件、多功能哺乳枕、尿不湿、宝宝透气全面套装、玻璃奶瓶、抚触油护臀膏等。</div>
                    </div>
                  </li>
                  <hr style="clear: both">
                  <li class="d-praise">
                    <span class="num">05</span>
                    <img src="" class="d-img" alt="">
                    <div class="d-praise-con">
                      <p class="praise-name">宝宝护理</p>
                      <div class="praise-con">
                        早期智力开发激活+强健体魄<br>
                        （婴儿SPA+抚触、音乐训练、视力训练、骨骼锻炼等）
                        <br><br>
                        开展温馨满月Party<br>
                        (可免费剃胎发）<br><br>

                        个性化早早教服务<br>
                        （指导妈妈按摩方法沟通技巧，开展亲子游戏等，利于母婴情感交流）<br>
                        <br>
                        婴儿托管服务<br>
                        （月子期间为帮助妈妈精心修养，提供专业婴儿室托管服务，由护士团队负责护理。帮助宝宝培养良好睡眠习惯和集体生活意识）
                      </div>
                    </div>
                  </li>
                  <hr style="clear: both">
                </ul>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="ser-e">
              <h3 class="meal-title"><span clas="title-line"></span>合美月子优势<span class="title-line"></span></h3>
              <el-carousel :interval="4000" type="card" height="406px" interval="300000">
                <el-carousel-item v-for="item in serE" :key="item.id">
                  <div class="hideE">
                    <img :src="item.src" class="imgE" alt="">
                  </div>

                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "setmeal",
      data(){
          return{
            index:1,
            diaryCarList:[
              {
                name:'环境一览 ',
                id:1
              },
              {
                name:'服务项目 ',
                id:2
              },
            ],
            envA:[
              {
                id:1,
                src:'../../static/img/setmeal/env-a-1.png',
                name:'优享套餐',
                ann:'高性价比  众多妈妈力推爆款'
              },
              {
                id:2,
                src:'../../static/img/setmeal/env-a-2.png',
                name:'悦享套餐',
                ann:'经典房型  温馨超值修养套餐'
              },
              {
                id:3,
                src:'../../static/img/setmeal/env-a-3.png',
                name:'尊享套餐',
                ann:'顶级配置 一对一专业全天呵护'
              },
              {
                id:4,
                src:'../../static/img/setmeal/env-a-4.png',
                name:'臻享套餐',
                ann:'限量专享 超大空间满足全家需求'
              },
            ],
            envB:[
              {
                id:1,
                src:'../../static/img/setmeal/env-b-1.png',
                name:'房间四季如春新风循环更健康',
                ann:'独立中央空调体系自主温度调节；独立地\n' +
                  '暖系统让冬季保持房间恒温如春；24h循\n' +
                  '环鲜风系统及空气净化加湿设施保障人体\n' +
                  '健康。'
              },
              {
                id:2,
                src:'../../static/img/setmeal/env-b-2.png',
                name:'专业隔音打造独立无束私密空间',
                ann:'专业的隔音门窗、墙体设计，保证给妈妈宝宝营造静谧舒适的生活空间；灯光标准全面符合母婴需求配备防伤眼保护。'
              },
              {
                id:3,
                src:'../../static/img/setmeal/env-b-3.png',
                name:'室内装修采用绿色环保材料',
                ann:'室内水性科天无毒装修+器材零甲醛。品牌软水直饮水过滤器、进口家私、智能坐便器等；定期紫外线机器消毒杜绝细菌感染，充分保证母婴健康。'
              },
              {
                id:4,
                src:'../../static/img/setmeal/env-b-4.png',
                name:'品牌母婴生活护理设备',
                ann:'妈妈的床采用进口品牌高级床垫，更有防溢奶专业婴儿床。室内配有品牌消毒锅、暖奶器、调奶器、痔疮垫等设备。'
              },
              {
                id:5,
                src:'../../static/img/setmeal/env-b-5.png',
                name:'房型多样可选风格温馨典雅',
                ann:'软装风格简洁自然、清新舒适，又注重实用功能。含有超大双人床、婴儿床、干湿分离卫生间、配备网络电视。公寓式单间+VIP一房/厅/卫套房自选。'
              },
              {
                id:6,
                src:'../../static/img/setmeal/env-b-6.png',
                name:'5A风景区环境优美适宜修养',
                ann:'合美临近淹城风景区周边环境无商业大厦，家庭式入驻环境及露天阳台让视野更加开\n' +
                  '阔明亮，益于妈妈身心修养和宝宝成长。'
              },
            ],
            envC:[
              {
                id:1,
                src:'../../static/img/setmeal/env-c-1.png',
                name:'产后康复专区',
                ann:'产后专用功能房，一房一功能，绝不交叉使用，保证隐私和卫生安全；专业修复师一对一单独服务+先进设备康复治疗，配备传统中药熏蒸室，让妈妈加速恢复，更能预防产后月子病。'
              },
              {
                id:2,
                src:'../../static/img/setmeal/env-c-2.png',
                name:'瑜伽健身专区',
                ann:'月子中心特设医药标准级VIP瑜伽房，恒温恒湿；专业瑜伽老师个性化定制月子瑜伽课程，通过专业有效的指导让妈妈尽快恢复孕前身材，找回美丽自己。'
              },
              {
                id:3,
                src:'../../static/img/setmeal/env-c-3.png',
                name:'乳房管理专区',
                ann:'理疗专区配备定制美容床，可根据产后妈妈的体质进行自动发热调节温度，加上自动调高低让妈妈有一个舒服的姿势进行护理。专业人员将更科学地指导母乳喂养、采用无痛通乳手法进行日常护理。'
              },
              {
                id:4,
                src:'../../static/img/setmeal/env-c-4.png',
                name:'宝宝阳光房护理站',
                ann:'专区地板墙面选用三甲医院级医疗洁净板，防菌零感染；360度全玻璃包围设计，让宝宝边享受边看世界；家人可全方位观察宝宝行为，记录宝宝抚触护理全过程等。\n' +
                  '24小时专人看护的育婴室采用落地隔音玻璃式设计，远离杂音；特设柔光确保宝宝眼睛健康，不受到任何伤害；所有的陈设家具，都尽可能使用圆角设计，保证宝宝的安全体验。'
              },
              {
                id:5,
                src:'../../static/img/setmeal/env-c-5.png',
                name:'婴儿游泳馆',
                ann:'特设会员婴儿游泳专区，只针对会所内的宝宝，不对外开放，私秘性强，安全性高。专业亲切的Baby健康师协助宝宝游泳、沐浴、抚触，让每位宝宝尽享舒适与健康。 '
              },
              {
                id:6,
                src:'../../static/img/setmeal/env-c-6.png',
                name:'多功能生活专区',
                ann:'为满足各种需求，百分百达到一站式服务，合美特设宽敞的多功能活动室。妈妈可参与不定期绘画及烘焙手工课，丰富月子生活。该地也经常承办宝宝满月派对、母婴座谈会等活动。'
              },
            ],
            serA:[
              {
                id:1,
                src:'../../static/img/setmeal/ser-a-1.png',
                name:'坐落5A景区',
                ann:'营造幽静舒适坐月子环境'
              },
              {
                id:2,
                src:'../../static/img/setmeal/ser-a-2.png',
                name:'五星标准装修',
                ann:'私密无束空间如家般温馨'
              },
              {
                id:3,
                src:'../../static/img/setmeal/ser-a-3.png',
                name:'五星健康保障',
                ann:'医疗级管控预防交叉感染'
              },
              {
                id:4,
                src:'../../static/img/setmeal/ser-a-4.png',
                name:'五星安保设施',
                ann:'24小时门禁系统实时监控'
              },
              {
                id:5,
                src:'../../static/img/setmeal/ser-a-5.png',
                name:'五星生活协助',
                ann:'私人管家与亲友访问接待'
              },
            ],
            serD:[
              {
                id:1,
                src:'../../static/img/setmeal/ser-c-1.png',
                name:'全面陪护',
                ann:'分娩出院专车入所   坐月子1V1+24小时护理<br>' +
                  '家属特色专属餐食   新手爸妈免费课堂<br>' +
                  '孕期写真新生儿照   出所宝妈指导服务<br>' +
                  '（产后饮食指导、免费保健咨询、新生儿作息睡眠辅食指导、<br>' +
                  '卫教育儿指导、育儿知识分享等）'
              },
              {
                id:2,
                src:'../../static/img/setmeal/ser-a-1.png',
                name:'孕期护理',
                ann:'秘方中药养发头疗  孕期肿胀舒缓、防妊娠纹服务'
              },
              {
                id:3,
                src:'../../static/img/setmeal/ser-a-1.png',
                name:'产后康复',
                ann:'产后腰肩/下肢水肿舒缓护理   子宫复旧伤口红外理疗<br>' +
                  '中药医学暖宫温阳服务   盆底肌腹直肌修复服务<br>' +
                  '纤体塑性、乳房保养   产后42天盆底健康评估'
              },
              {
                id:4,
                src:'../../static/img/setmeal/ser-a-1.png',
                name:'全套用品',
                ann:'暖吸汗月子服、产妇专用护齿套件、多功能哺乳枕、尿不湿、宝宝透气全面套装、玻璃奶瓶、抚触油护臀膏等。'
              },
              {
                id:5,
                src:'../../static/img/setmeal/ser-a-1.png',
                name:'宝宝护理',
                ann:'早期智力开发激活+强健体魄<br>' +
                  '（婴儿SPA+抚触、音乐训练、视力训练、骨骼锻炼等）<br>' +
                  '<br>' +
                  '开展温馨满月Party <br>' +
                  '(可免费剃胎发）<br>' +
                  '<br>' +
                  '个性化早早教服务\n' +
                  '（指导妈妈按摩方法沟通技巧，开展亲子游戏等，利于母婴情感交流）<br>' +
                  '<br>' +
                  '婴儿托管服务<br>' +
                  '（月子期间为帮助妈妈精心修养，提供专业婴儿室托管服务，由护士团队负责护理。帮助宝宝培养良好睡眠习惯和集体生活意识）'
              },
            ],
            serE:[
              {
                id:1,
                src:'../../static/img/setmeal/1.png'
              },
              {
                id:2,
                src:'../../static/img/setmeal/2.png'
              },
              {
                id:3,
                src:'../../static/img/setmeal/3.png'
              },
              {
                id:4,
                src:'../../static/img/setmeal/4.png'
              },
              {
                id:5,
                src:'../../static/img/setmeal/5.png'
              },
              {
                id:6,
                src:'../../static/img/setmeal/6.png'
              },
              {
                id:7,
                src:'../../static/img/setmeal/7.png'
              },
              {
                id:8,
                src:'../../static/img/setmeal/8.png'
              },
            ]
          }
      },
      methods:{
        setActive:function (id) {
          this.index = id;
        },
      }
    }
</script>

<style scoped lang="less">
  @font-face{
    font-family: 'ownnum';
    src : url('../../static/font/Knockout-HTF27-JuniorBantamwt.otf');
  }
  .setmeal{
    .el-radio-group{
      display: flex;
      justify-content: center;
      margin:0 auto 20px!important;
      .el-radio-button__inner{

      }
      .el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background-color: #fff!important;
        color:#f79200;
      }
    }
    .el-carousel{
      background-color: #000;
      .is-active{
        transform: scale(0.83) translateX(312.5px)!important;
      }
      .el-carousel__item.is-in-stage{
        color: #475669;
        font-size: 14px;
        opacity: 0.73;
        line-height: 200px;
        margin: 0;
      }
      .el-carousel__item.is-active{
        color: #475669;
        font-size: 14px;
        opacity: 1;
        line-height: 200px;
        margin: 0;
      }
      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
      }
    }
    
    .content{
      .bread{
        margin-bottom: 20px;
        font-size: 12px;
        color:#999999;
        .el-breadcrumb{
          vertical-align: middle;
          display: inline-block;
          span{
            font-size: 12px;
            color:#999999;
          }
        }
      }
      .taggle-box{
        ul{
          display: flex;
          flex-direction: row;
          justify-content: center;
          .fun-carousel{
            width: 186px;
            height: 36px;
            color:#666666;
            text-align: center;
            line-height: 36px;
            border-radius: 18px;
            float: left;
            cursor: pointer;
            border: 1px solid #666666;
            margin-right: 30px;
            &:last-child{
              margin-right: 0;
            }
          }
          .fun-carousel.active{
            background-color: #c2874e;
            color:#ffffff;
            border-color: #c2874e;
          }
        }
      }
      .meal-title{
        margin-bottom: 50px;
        text-align: center;
        font-size: 28px;
        line-height: 32px;
        font-weight: 500;
        .title-line{
          width: 65px;
          height: 1px;
          margin:0 30px;
          display: inline-block;
          background-color: #cccccc;
          vertical-align: middle;
        }
      }
    }
    .env{
      .content{
        padding: 60px 0;
      }
      .env-a{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .env-a-item{
          width: 297px;
          height: 315px;
          border: 1px solid #e5e5e5;
          background-color: #fff;
          transition: all 0.3s ease;
          &:hover{
            box-shadow: 0 6px 6px 0px rgba(0,0,0,0.2);
          }
          .aImg{
            width: 100%;
            height: 210px;
            margin-bottom: 20px;
          }
          .name{
            text-align: center;
            font-size: 18px;
            line-height: 24px;
            margin-bottom: 12px;
            color:#333333;
          }
          .env-ann{
            text-align: center;
            font-size: 14px;
            line-height: 18px;
            color:#666666;
          }
        }
      }
      .env-b{
        width: 100%;
        background-color: #f3ebde;
        .b-item{
          float: left;
          width: 398px;
          height: 162px;
          background-color: #fff;
          margin: 0 27px 20px 0;
          padding: 28px 30px;
          display: flex;
          flex-direction: row;
          &:nth-child(3n){
            margin-right: 0;
          }
          .imgB{
            width: 68px;
            height: 68px;
            margin-right: 18px;
          }
          .b-text{
            display: flex;
            flex-direction: column;
            .b-name{
              font-size: 18px;
              margin-bottom: 16px;
            }
            .b-ann{
              font-size: 14px;
              color:#666666;
              line-height: 19px;
            }
          }
        }
      }
      .sub-title{
        margin-bottom: 50px;
      }
      .env-c{
        .env-c-item{
          float: left;
          width: 398px;
          min-height: 438px;
          border: 1px solid #e5e5e5;
          background-color: #fff;
          transition: all 0.3s ease;
          margin:0 27px 20px 0;
          &:nth-child(3n){
            margin-right: 0;
          }
          &:hover{
            box-shadow: 0 6px 6px 0px rgba(0,0,0,0.2);
          }
          .cImg{
            width: 100%;
            height: 265px;
            margin-bottom: 20px;
          }
          .env-c-box{
            padding: 0 27px 27px;
            .name{
              text-align: center;
              font-size: 18px;
              line-height: 24px;
              margin-bottom: 12px;
              color:#333333;
            }
            .env-ann{
              text-align: center;
              font-size: 14px;
              line-height: 18px;
              color:#666666;
            }
          }
        }
      }

    }
    .server{
      .content{
        padding: 60px 0;
      }
      .ser-a{
        .ser-a-box{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .ser-a-item{
            width: 184px;
            .aSer{
              margin:0 auto 18px;
              width: 108px;
              height: 70px;
              display: block;
            }
            .a-name,.a-ann{
              text-align: center;
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
      .ser-b{
        background-color: #F3EBDE;
        .b-content{
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: row;
          .b-main-img{
            display: block;
            width: 400px;
            height: 494px;
          }
          .b-article{
            width: 517px;
            line-height: 20px;
            font-size: 14px;
          }
          .photo{
            width: 242px;
            img:first-child{
              margin-bottom: 50px;
            }
          }
        }
      }
      .ser-c{
        .c-article{
          height: 336px;
          column-count: 2;
          column-gap: 72px;
          line-height: 26px;
          margin-bottom: 30px;
          .envi-c{
            display: flex;
            justify-content: space-between;
            margin-top: 22px;
          }
        }
        .c-botton-line{
          width: 100%;
          border-top: 1px dashed #F3EBDE;
          position: relative;
          &:after{
            content:'';
            position: absolute;
            top: -1px;
            left: 590px;
            margin-right: -35px;
            height: 2px;
            width: 70px;
            background-color: #fff;
          }
        }
      }
      .ser-d{
        background-color: #F3EBDE;
        .d-content{
          width: 100%;
          border-top: 1px solid #dbcfbd;
          .d-praise{
            float: left;
            width: 50%;
            display: flex;
            flex-direction: row;
            padding: 30px 0 ;
            .num{
              font-family: 'ownnum';
              font-size: 72px;
              margin-right: 18px;
            }
            .d-img{
              width: 163px;
              height: 107px;
              background-color: #cccccc;
              margin-right: 18px;
            }
            .d-praise-con{
              width: 354px;
              display: flex;
              flex-direction: column;
              .praise-name{
                font-size: 18px;
                margin-bottom: 18px;
              }
              .praise-con{
                font-size: 14px;
                line-height: 26px;
              }
            }
          }
          hr{
            height: 1px;
            border: none;
            background-color: #dbcfbd;
          }
        }
      }
      .ser-e{
        .imgE{
          width: 100%;
        }
      }
    }
  }
</style>
<style lang="less">

  .setmeal{
    .el-carousel{
      border-left: 40px solid #000;
      border-right: 40px solid #000;
    }
    .el-carousel__indicators--outside{
      margin-top: -30px;
    }
    .el-carousel__indicator--horizontal.is-active .el-carousel__button{
      background-color: #FFAE00;
    }
    .el-carousel__indicator--horizontal .el-carousel__button{
      padding: 0;
      width: 15px;
      height: 15px;
      border-radius: 50%;
    }
    .el-radio-button__inner{
      &:hover{
        color:#ffffff;
        background-color: #f79200!important;
      }
    }
    .is-active .el-radio-button__inner{
      background-color: #f79200!important;
      color:#ffffff!important;
      border-color: #e5e5e5 !important;
      box-shadow: none!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/setmeal.vue